module.exports = __webpack_public_path__ + "img/pointer.eafe35a.svg";